import VendorQuickAddHtml from './vendor.quick-add.html';

export function VendorService ($uibModal, inheritorApi, VendorLite) {
  var Vendor = function (vendor) {
    this.vendor = vendor;

    inheritorApi.inherit(this, VendorLite)
  };

  inheritorApi.bootstrap(Vendor, VendorLite);

  Vendor.quickAdd = function () {
    return $uibModal.open({
      templateUrl: VendorQuickAddHtml,
      windowClass: 'md-modal',
      controller: 'VendorQuickAddCtrl'
    }).result;
  };

  return Vendor;
}